const searchEl = document.query('.slx-search');
const headerEl = document.query('.slx-header');
if (searchEl) {
	searchEl.addEventListener('layoutOpen', () => {
		headerEl.classList.add('searchActive');
	});
	searchEl.addEventListener('layoutClose', () => {
		headerEl.classList.remove('searchActive');
	});
}
